module.exports = __webpack_public_path__ + "static/media/projects-ai.d0fc0faf.svg";